function initIr() {
	irCalendarPage();
	irReportsListPage();
	irGatheringsPage();
	irModuleQuarterlyDataTable();
	irChart();
}
